<!-- Step 4 body — Confirmation read-back (handoff §Step 4). -->

<vb-banner
    *ngIf="isPickupBranch && !scheduleLater"
    tone="warn"
    class="con-banner">
    <p class="con-banner__line">
        <strong>Reminder:</strong> any other outstanding invoices will be added
        to this appointment.
    </p>
    <p class="con-banner__line">
        Invoices from events.viewbid.ca are not included.
        <a
            class="con-banner__link"
            [href]="eventsPurchasesUrl"
            target="_blank"
            rel="noopener noreferrer">
            Schedule those separately
        </a>
        on events.viewbid.ca.
    </p>
</vb-banner>

<p class="con-lead">Please review your order:</p>

<div class="con-rows">
    <div class="con-row" *ngIf="isPickupBranch">
        <span class="con-row__label">
            {{
                selectedDeliveryMethod === 'pickup'
                    ? 'Pickup'
                    : 'Self-service pickup'
            }}
        </span>
        <span class="con-row__value">
            {{ selectedDate | vbDate }}
            {{ selectedSlot?.slotLabel }} {{ selectedSlot?.zone }}
        </span>
    </div>

    <div class="con-row" *ngIf="selectedDeliveryMethod === 'proxyPickup'">
        <span class="con-row__label">Picked up by</span>
        <span class="con-row__value">{{ proxyName }} · {{ proxyTelephone }}</span>
    </div>

    <div class="con-row" *ngIf="selectedDeliveryMethod === 'shipping'">
        <span class="con-row__label">Shipping to</span>
        <span class="con-row__value">{{ shipLine }}</span>
    </div>

    <div class="con-row" *ngIf="!isPaidInFull">
        <span class="con-row__label">Payment</span>
        <span class="con-row__value con-row__value--num">
            <ng-container *ngIf="selectedPaymentCard">
                {{ selectedPaymentCard.cardNumber }} ·
            </ng-container>
            <ng-container *ngIf="isPayOnPickup">Pay on pickup ·</ng-container>
            ${{ invoiceDetails?.invoice?.amountDue | number: '1.2-2' }}
        </span>
    </div>
</div>

<p class="con-help">
    Check the total in your order summary, then confirm to complete your order.
</p>

<p class="con-idnote" *ngIf="selectedDeliveryMethod === 'proxyPickup'">
    The person collecting must bring a copy of this invoice and
    government-issued photo ID.
</p>
